export enum AuthorizationActions {
  CREATE = "create",
  READ = "read",
  UPDATE = "update",
  DELETE = "delete",
}

export type AuthorizationActionList = AuthorizationActions[];
